<template>
    <div id="book-thumb-container"
         class="full-size"
         :style="data.styleBookListContainer"
    >
        <template v-for="(book, index) in ebooklist">
            <div class="thumbnail-entry"
                 :style="data.styleThumbnail"
                 v-show="isShowBookEntry(book)"
            >
                <img :src="getEbookCoverURL(book.ebooks[0].ebookcoverurl, book.ebooks[0].ebookcode)"
                     class="cover-img"
                     onerror="this.onerror=null;this.style.display='none'; this.previousSibling.style.display='block'"
                >
                <div class="book-info">
                    <a href="javascript:void(0)"
                       class="btn-toggle-publisher full-size"
                       @click.prevent="togglePublisher(index)"
                    >
                        <div class="seriesname">{{ book.ebookseriesname }}</div>
                        <div class="bookname">{{ book.ebookname}}</div>
                        <img class="icon-toggle-publisher"
                             :id="`icon-toggle-publisher-${index}`"
                             src="~images/icon-toggle-publisher.png"
                        >
                    </a>
                </div>

                <div class="publisher" :id="`publisher-${index}`">
                    <img :src="appendAccessToken(book.publisher.publishernamesmalllogo)">
                </div>

                <ul class="modules"
                    :id="'module' + index"
                >
                    <template v-for="(module, moduleindex) in book.ebooks"
                    >
                        <li v-show="isShowModule(book, module.ebookmodulename)">
                            <router-link :to="{ name: 'Reader', query: {ebookcode:  module.ebookcode} }" >
                                {{ module.ebookmodulename }}
                            </router-link>
                        </li>
                    </template>

                </ul>
            </div>
        </template>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed}  from "vue";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useBookList} from "@/modules/home/booklist";
    import FooterHome from "@/views/footer/FooterHome";
    import HeaderHome from "@/views/header/HeaderHome";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';
    import {appendAccessToken} from  "@/modules/utils/pathUtils";

    export default {

        setup(props, context) {

            let timeoutWinResizeId
            const {booklistState, isShowBookEntry, isShowModule, getEbookCoverURL} = useBookList();
            const thumbnailMaxCol = config.home.thumbnailMaxCol;
            const thumbnailWidth = parseInt(cssvar.homeThumbWidth);
            const thumbnailMargin = parseInt(cssvar.homeThumbMargin);
            const thumbnailBorderWidth = parseInt(cssvar.homeThumbBorderSize);

            const data = reactive({
                styleThumbnail: {
                    width:`${thumbnailWidth}px`,
                    borderWidth:`${thumbnailBorderWidth}px`,
                    margin:`${thumbnailMargin}px`
                },
                bookListContainerWidth:0
            })

            data.styleBookListContainer = computed(()=>{
                return {
                    width: `${data.bookListContainerWidth}px`
                }
            })

            const ebooklist = computed(()=>{
                return JSON.parse(localStorage.ebooklist);
            });

            const windowOnResized = (e)=>{
                //add a timeout to avoid window resize from firing twice, and make orientationChange event get the width correctly
                window.clearTimeout(timeoutWinResizeId);
                timeoutWinResizeId = window.setTimeout(()=>{
                    updateThubmnailDisplay();
                }, 500);
            }


            /**
             * Determine how many columns to fit the window and update the container width
             */
            const updateThubmnailDisplay = ()=> {
                let thumbnailFullWidth = (thumbnailWidth + (thumbnailMargin + thumbnailBorderWidth) * 2);
                let colCount = Math.floor(window.innerWidth / thumbnailFullWidth);
                colCount = Math.min(colCount, thumbnailMaxCol);
                data.bookListContainerWidth = colCount * thumbnailFullWidth;
            }


            const togglePublisher = (index)=> {
                let imgHeight =  document.querySelector(`#publisher-${index} img`).height;

                if (document.querySelector(`#publisher-${index}`).offsetHeight === 0) {
                    document.querySelector( `#icon-toggle-publisher-${index}`).classList.add("down")
                    document.querySelector(`#publisher-${index}`).style.height = `${imgHeight}px`;
                } else {
                    document.querySelector( `#icon-toggle-publisher-${index}`).classList.remove("down")
                    document.querySelector(`#publisher-${index}`).style.height = 0;
                }
            }


            onMounted(()=>{
                console.log("thumbviewmounted!!")
                if (!isTouchDevice()) {
                    window.addEventListener("resize", windowOnResized);
                } else {
                    window.addEventListener("orientationchange", windowOnResized);
                }
                updateThubmnailDisplay();
            });

            onUnmounted(()=>{
                window.removeEventListener("resize", windowOnResized);
            })

            return {
                data,
                ebooklist,
                booklistState,
                isShowBookEntry,
                isShowModule,
                getEbookCoverURL,
                appendAccessToken,
                togglePublisher
            }

        }
    }

</script>
<style scoped lang="scss">

    $book-list-padding-vertical:60px;

    @mixin set-thumbnail-col($colCount) {
        //Set percnetage by dividing 100 by column count. Minus the border and margin pixels that occupy the width
        .thumbnail-entry {
            width: calc(#{floor(100% /$colCount)} - #{$home-thumb-margin * 2} - #{$home-thumb-border-size * 2}) !important;
        }

        //we want some space between the window edge and the thumbnail, so we use the thumbnail margin to occupy the space as if padding.
        #book-thumb-container {
            width:100% !important;
            padding:$book-list-padding-vertical $home-thumb-margin !important;
            box-sizing: border-box;
        }
    }


    #book-thumb-container {
        display:flex;
        flex-flow: row wrap;
        padding: $book-list-padding-vertical 0;
        margin:0 auto;
    }

    .thumbnail-entry {
        margin:4px;
        border-style: solid;
        border-color:$border-color-lighter;
        border-radius:10px;
        overflow:hidden;
        background:#fff;
    }

    @include responsive(mobile-tiny) {
        @include set-thumbnail-col(1);
    }

    @include responsive(mobile) {
        @include set-thumbnail-col(2);
    }


    @include responsive(mobile-large) {
        @include set-thumbnail-col(2);
    }

    @include responsive(mobile-mega) {
        @include set-thumbnail-col(3);
    }

    .seriesname {
        font-size:14px;
    }

    .bookname {
        font-size:16px;
        margin:3px 0;
        color:#000;
    }

    .btn-toggle-publisher {
        color:#000;

    }

    .book-info {
        padding: 8px;
        background:$color-primary-lighter;
        position: relative;
        line-height:1.3em;
        align-items: center;
        position:relative;
    }

    .modules li a {
        font-size:15px;
        padding:8px;
        display:block;
        background:#fff;
        color:$text-color-primary;
        @include transition(background, 0.4s, ease-in);
        &:hover {
            background:$grey;
        }
    }

    .publisher {

        margin:4px 0;
        overflow:hidden;
        height:0;
        @include transition(all, 0.3s);

        img {
            width:100%;
        }
    }

    .publisher.close {
        height:0;
    }

    .cover-img {
        width:100%;
    }


    .icon-toggle-publisher {
        position:absolute;
        top:8px;
        right:8px;
        @include transition(all, 0.1s);

        &.down {
            transform:rotate(180deg);
        }
    }


</style>